<section class="aarni-font relative w-full pt-[350px] pb-[50px] object-cover mt-[80px]"
         [ngStyle]="{
             'background-image': getBackgroundImage(),
             'background-size': 'cover',
             'background-position': '',
             'background-repeat': 'no-repeat'
         }">
    <div class="container mx-auto px-4">
        <h1 class="uppercase text-center md:text-start font-bold text-white text-[32px] shadow">
            {{ pageTitle }}
        </h1>
        <div class="flex flex-col justify-center items-center md:justify-start md:flex-row mt-6">
            <button class="bg-gold text-white px-4 py-2 rounded-3xl font-semibold mb-4 md:mb-0 w-fit"
                    (click)="goTo('/programs/graduate')">
                Find Program <i class="fa-solid fa-magnifying-glass text-[12px] ml-4"></i>
            </button>
            <button class="bg-gold text-white px-14 py-2 md:ml-6 rounded-3xl font-semibold w-fit"
                    (click)="goTo('/form/apply-form')">
                Apply Now
            </button>
        </div>
    </div>
</section>


<section class="aarni-font">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 h-fit overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Campus Life</h2>
                    <div class="">
                        <a
                            routerLink="/whats-happening/event-calendar"
                            routerLinkActive="bg-blue-600 text-white border-blue-400"
                            class="flex items-center space-x-2 p-3 w-full text-blue-600 border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Event Calendar</span>
                        </a>
                        <a [href]="'/whats-happening/upcoming-events'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Upcoming Events', 'text-blue-600 bg-white' : pageTitle !== 'Upcoming Events'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Upcoming Events</span>
                        </a>
                        <a [href]="'/whats-happening/announcements'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Announcements', 'text-blue-600 bg-white' : pageTitle !== 'Announcements'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Announcements</span>
                        </a>
                        <a [href]="'/campus-life/transportation'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Transportation', 'text-blue-600 bg-white' : pageTitle !== 'Transportation'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Transportation</span>
                        </a>
                        <a [href]="'/campus-life/residential-facilities'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Residential Facilities', 'text-blue-600 bg-white' : pageTitle !== 'Residential Facilities'}"
                             class="flex items-center space-x-2 p-3 w-full  border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Residential Facilities</span>
                        </a>
                        <a [href]="'/campus-life/library'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Library', 'text-blue-600 bg-white' : pageTitle !== 'Library'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Library</span>
                        </a>
                        <a [href]="'/campus-life/schools'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Schools', 'text-blue-600 bg-white' : pageTitle !== 'Schools'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Schools</span>
                        </a>
                        <a [href]="'/campus-life/auditorium'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Auditorium', 'text-blue-600 bg-white' : pageTitle !== 'Auditorium'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Auditorium</span>
                        </a>
                        <a [href]="'/campus-life/it-services'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'IT Services', 'text-blue-600 bg-white' : pageTitle !== 'IT Services'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>IT Services</span>
                        </a>
                        <a [href]="'/campus-life/green-campus'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Green Campus', 'text-blue-600 bg-white' : pageTitle !== 'Green Campus'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Green Campus</span>
                        </a>
                        <a [href]="'/campus-life/ncc'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'NCC', 'text-blue-600 bg-white' : pageTitle !== 'NCC'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>NCC</span>
                        </a>
                        <a [href]="'/campus-life/extra-curricular-activities'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Extra Curricular Activities', 'text-blue-600 bg-white' : pageTitle !== 'Extra Curricular Activities'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Extra Curricular Activities</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4">Quick Links</h2>
            <div
                class="bg-white p-4 rounded-lg shadow border-gray-200 border-2"
            >
                <div class="space-y-2">
                    <div class="flex items-center space-x-3 p-2 rounded-lg">
                        <div
                            class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full"
                        >
                            <i class="fa fa-comment text-2xl"></i>
                        </div>
                        <div class="text-gray-700 font-medium ml-2">
                            Testimonials
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="bg-white p-4 rounded-lg shadow border-gray-200 border-2"
            >
                <div class="space-y-2">
                    <div class="flex items-center space-x-3 p-2 rounded-lg">
                        <div
                            class="w-16 h-16 flex items-center justify-center bg-yellow-500 text-white rounded-full"
                        >
                            <i class="fa fa-calendar text-2xl"></i>
                        </div>
                        <div class="text-gray-700 font-medium ml-2">
                            What's Happening
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="bg-white p-4 rounded-lg shadow border-gray-200 border-2"
            >
                <div class="space-y-2">
                    <div class="flex items-center space-x-3 p-2 rounded-lg">
                        <div
                            class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full"
                        >
                            <i class="fa fa-phone text-2xl"></i>
                        </div>
                        <div class="text-gray-700 font-medium ml-2">
                            Contact Us
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="bg-white p-4 rounded-lg shadow border-gray-200 border-2"
            >
                <div class="space-y-2">
                    <div class="flex items-center space-x-3 p-2 rounded-lg">
                        <div
                            class="w-16 h-16 flex items-center justify-center bg-blue-600 text-white rounded-full"
                        >
                            <i class="fa fa-camera text-2xl"></i>
                        </div>
                        <div class="text-gray-700 font-medium ml-2">
                            Image Gallery
                        </div>
                    </div>
                </div>
            </div>
        </aside>
        <div class="flex-1">
            <div class="p-12 shadow-lg border-gray-200 bg-white h-fit border">
                <h3 class="font-semibold text-[22px]">
                    {{ pageTitle }}
                </h3>
                <div *ngIf="pageTitle === 'Infrastructure'">
                    <h5 class="font-semibold text-[18px] mt-10 text-gray-700">
                        Academic Blocks
                    </h5>

                    <p class="mt-8 text-[14px]">
                        The University has an extremely well designed infrastructure of approx eight Academic Blocks and
                        very well equipped with state-of-the-art Laboratories, to inspire students to learn their
                        lessons in a very congenial environment. The class rooms have all modern learning aids/ comforts
                        to activate all senses of the students and make them learning savvy. The class rooms and Seminar
                        Halls are also equipped with the latest teaching aids and presentation tools.
                    </p>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-4 mt-6">
                        <div *ngFor="let image of academicBlockImages" class="border shadow w-full">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                            <div class="font-semibold flex items-center justify-center py-4">
                                {{ image.name | titlecase }}
                            </div>
                        </div>
                    </div>

                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Library Facilities
                    </h5>

                    <p class="mt-4 text-[14px]">
                        The University Library has been up-graded to the Best Library in the state of Himachal Pradesh
                        and in the entire surrounding areas. It has now approx 28000 books of different streams , has
                        facilities of e-journals and is fully air-conditioned to provide ideal environment for the
                        students. The Library has a large number of national and international journals in the field of
                        Management, Technology, Science and Arts.
                    </p>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of libraryImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>

                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Mess Facilities
                    </h5>
                    <p class="mt-4 text-[14px]">
                        The University has two separate large Dining Halls for the Boy and Girl hostellers, connected
                        with their Hostels to ensure their better time management and security. The menu is decided by
                        the Mess Committee, comprising of students from all hostels and the Wardens. The Mess charges
                        are paid in advance for whole Semester, in the beginning of each Semester along with other
                        charges of the University.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of messImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>


                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Sports Facilities
                    </h5>
                    <p class="mt-4 text-[14px]">
                        The University thinks about the all round emotional and physical development of our students.
                        With a view to look into these very important aspects, the University has almost all indoor and
                        outdoor sports facilities for the students, including modern gyms, within the Campus. Also, we
                        have instructors of national fame to guide students in an appropriate manner. The facilities
                        are:
                    </p>
                    <ul class="list-disc italic ml-6 mt-8 text-[14px]">
                        <li>
                            Cricket
                        </li>
                        <li>
                            Football
                        </li>
                        <li>
                            Basketball
                        </li>
                        <li>
                            Hockey
                        </li>
                        <li>
                            Volleyball
                        </li>
                        <li>
                            Lawn Tennis
                        </li>
                        <li>
                            Table Tennis
                        </li>
                        <li>
                            Badminton
                        </li>
                        <li>
                            Kho Kho
                        </li>

                    </ul>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of sportsFacilitiesImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>

                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Hostel Facilities
                    </h5>
                    <p class="mt-4 text-[14px]">
                        There are separate Hostels for Boys and Girls with all the modern and comfort facilities. The
                        rooms are well furnished, spacious and airy to enable the living of students as comfortable as
                        possible. In fact it is with a concept to have “Home away from Home”. We cater for approx 700
                        students on double and triple sharing basis. We pay special attention for the safety and
                        comforts of the students, especially the Girl students so that they all feel secured,
                        comfortable and confident.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of hostelImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>

                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Gym Facilities
                    </h5>
                    <p class="mt-4 text-[14px]">
                        There are separate Gym for Boys and Girls with all the modern and comfort facilities. The
                        Machine are well furnished, spacious and airy to enable the living of students as comfortable as
                        possible. In fact it is with a concept to have “Home away from Home”. We cater for approx 100
                        students on double and triple sharing basis. We pay special attention for the safety and
                        comforts of the students, especially the Girl students so that they all feel secured,
                        comfortable and confident.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of gymImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>

                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Transport Facilities
                    </h5>
                    <p class="mt-4 text-[14px]">
                        The University caters for a “Pick up from Home” facility for our students from all the
                        surrounding areas of Himachal Pradesh, Punjab and J&K. Transport charges are required to be paid
                        in full, in advance, in the beginning for the whole Semester Charges once paid, cannot be
                        withdrawn.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of transportationImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>

                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Medical Facilities
                    </h5>
                    <p class="mt-4 text-[14px]">
                        Arni has 10 bedded “Central Medical Clinic” with trained medical staff and Ambulance. We also
                        have adequate stock of all important medicines and necessary latest equipment required to take
                        immediate medical care of our students, staff and the faculty. In addition, “First Aid Boxes”
                        have been provided in all Hostels and public transport. Tie –up with the Civil Hospitals has
                        also been done in case of emergency requirement.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 mt-6">
                        <div *ngFor="let image of medicalFacilitiesImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[250px]">
                        </div>
                    </div>

                </div>
                <div *ngIf="pageTitle === 'Academic Facilities'">
                    <p class="mt-8 text-[14px]">
                        Aarni University offers a world-class campus with modern facilities designed to enhance the
                        learning experience. Its classrooms are equipped with ceiling-mounted projectors and advanced
                        digital tools, creating an interactive and engaging environment. The university regularly hosts
                        national and international conferences and seminars, fostering industry collaboration and
                        academic excellence.
                    </p>
                    <p class="mt-4 text-[14px]">
                        Aarni’s auditoriums feature state-of-the-art multimedia systems, making them ideal for
                        presentations, seminars, and cultural events. The well-stocked libraries provide students with
                        access to a vast collection of books, journals, and research materials. With a strong focus on
                        innovation, the university continuously upgrades its infrastructure and technical facilities.
                        Cutting-edge laboratories offer hands-on experience, allowing students to apply theoretical
                        knowledge through practical experimentation.
                    </p>
                </div>
                <div *ngIf="pageTitle === 'Campus Facilities' || pageTitle === 'Residential Facilities'">
                    <h5 class="font-semibold text-[18px] mt-10 text-gray-700">
                        Hostel Facilities
                    </h5>
                    <p class="mt-8 text-[14px]">
                        There are separate Hostels for Boys and Girls with all the modern and comfort facilities. The
                        rooms are well furnished, spacious and airy to enable the living of students as comfortable as
                        possible. In fact it is with a concept to have “Home away from Home”. We cater for approx 700
                        students on double and triple sharing basis. We pay special attention for the safety and
                        comforts of the students, especially the Girl students so that they all feel secured,
                        comfortable and confident.

                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of hostelImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>
                    <h5 class="font-semibold text-[18px] mt-10 text-gray-700">
                        Mess Facilities
                    </h5>
                    <p class="mt-4 text-[14px]">
                        The University has two separate large Dining Halls for the Boy and Girl hostellers, connected
                        with their Hostels to ensure their better time management and security. The menu is decided by
                        the Mess Committee, comprising of students from all hostels and the Wardens. The Mess charges
                        are paid in advance for whole Semester, in the beginning of each Semester along with other
                        charges of the University.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of messImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Schools'">
                    <p class="mt-8 text-[14px]">
                        Aarni University is home to a diverse range of schools, each dedicated to fostering excellence
                        in education, research, and innovation. With a commitment to interdisciplinary learning, the
                        university offers specialized schools that cater to various fields of study, ensuring students
                        receive a well-rounded and industry-relevant education.
                    </p>
                    <p class="mt-8 text-[14px]">
                        Each school at Aarni University is led by distinguished faculty members and industry experts,
                        providing students with an enriching academic environment. The curriculum is designed to blend
                        theoretical knowledge with practical application, preparing graduates to excel in their
                        respective fields.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 py-12 gap-8"
                         *ngIf="pageTitle === 'Schools'">
                        <div class="bg-white w-full shadow-lg border pb-6" *ngFor="let school of schools">
                            <div>
                                <img [src]="school.image_url" class="w-full h-auto" [alt]="school.name">
                            </div>
                            <h6 class="font-semibold text-[18px] pt-8 pb-6 px-4">
                                {{ school.name }}
                                <div class="bg-gold h-[2px] w-[32%]"></div>
                            </h6>
                            <p class="px-4 line-clamp-3 text-[14px]">
                                {{ school.description }}
                            </p>
                        </div>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Transportation'">
                    <p class="mt-8 text-[14px]">
                        The University caters for a “Pick up from Home” facility for our students from all the
                        surrounding areas of Himachal Pradesh, Punjab and J&K. Transport charges are required to be paid
                        in full, in advance, in the beginning for the whole Semester Charges once paid, cannot be
                        withdrawn. The areas connected are:
                    </p>
                    <ul class="list-disc italic ml-6 mt-8 text-[14px]">
                        <li>
                            Talwara – Mukerian – Arni.
                        </li>
                        <li>
                            Kathua – Pathankot- Arni.
                        </li>
                        <li>
                            Bhadwar – Nurpur- Arni.
                        </li>
                        <li>
                            Mehra Phatak-Gangath-Arni.
                        </li>
                        <li>
                            Jawali- Indora- Arni.
                        </li>
                        <li>
                            Dhameta-Rahan- Arni.
                        </li>
                        <li>
                            Badukhar-Indora-Arni.
                        </li>
                    </ul>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of transportationImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Library'">
                    <div class="flex gap-8">
                        <p class="mt-8 text-[14px] w-3/4">
                            The University Library has been up-graded to the Best Library in the state of Himachal
                            Pradesh and in the entire surrounding areas. It has now approx 28000 books of different
                            streams , has facilities of e-journals and is fully air-conditioned to provide ideal
                            environment for the students. The Library has a large number of national and international
                            journals in the field of Management, Technology, Science and Arts.
                        </p>
                        <ul class="mt-6">
                            <div class="font-medium text-primary-dark mb-4">Related Links</div>
                            <li class="text-[13px] text-blue-500 flex items-center">
                                <span
                                    class="w-[30px] h-[15px] mr-2 bg-gold text-white animate-pulse font-bold text-[8px] flex items-center justify-center rounded-full p-[3px]">NEW</span>
                                <a class="underline" href="https://www.ugc.gov.in/" target="_blank">e-Books@UGC
                                    Portal</a>
                            </li>
                            <li class="text-[13px] text-blue-500 flex items-center">
                                <span
                                    class="w-[30px] h-[15px] mr-2 bg-gold text-white animate-pulse font-bold text-[8px] flex items-center justify-center rounded-full p-[3px]">NEW</span>
                                <a class="underline"
                                   href="https://nptel.ac.in/"
                                   target="_blank">NPTEL (Home
                                    Page)</a>
                            </li>
                            <li class="text-[13px] text-blue-500 flex items-center">
                                <span
                                    class="w-[30px] h-[15px] mr-2 bg-gold text-white animate-pulse font-bold text-[8px] flex items-center justify-center rounded-full p-[3px]">NEW</span>
                                <a class="underline"
                                   href="https://ndl.iitkgp.ac.in/"
                                   target="_blank">NDL</a>
                            </li>
                            <li class="text-[13px] text-blue-500 flex items-center">
                                <span
                                    class="w-[30px] h-[15px] mr-2 bg-gold text-white animate-pulse font-bold text-[8px] flex items-center justify-center rounded-full p-[3px]">NEW</span>
                                <a class="underline"
                                   href="https://shodhganga.inflibnet.ac.in/"
                                   target="_blank">Shodhganga</a>
                            </li>
                            <li class="text-[13px] text-blue-500 flex items-center">
                                <span
                                    class="w-[30px] h-[15px] mr-2 bg-gold text-white animate-pulse font-bold text-[8px] flex items-center justify-center rounded-full p-[3px]">NEW</span>
                                <a class="underline"
                                   href="https://www.delnet.in/"
                                   target="_blank">Delnet</a>
                            </li>
                        </ul>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let image of libraryImages">
                            <img [src]="image.image_url" [alt]="image.name"
                                 class="w-full object-cover border h-[150px]">
                        </div>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Green Campus'">
                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        A Green Campus
                    </h5>
                    <p class="mt-8 text-[14px]">
                        A place where eco-friendly practices and education combine to promote eco-friendly practices on
                        campus. The Green Campus concept provides an opportunity for an educational institution to
                        redefine its eco-friendly culture and develop new paradigms by creating sustainable solutions
                        for the environmental, social, and economic needs of mankind.
                    </p>

                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Objectives of the Go Green Program
                    </h5>
                    <p class="mt-8 text-[14px]">
                        The first step of the Go Green Program involves establishing an operable Green-Campus Committee,
                        within the organizational structure. Hence, to give this initiative more clarity and
                        authenticity, we need to prepare an officially and fully functional and concrete POLICY
                        DOCUMENT.
                    </p>
                    <p class="mt-8 text-[14px]">
                        Greening the campus is all about sweeping away wasteful inefficiencies and using conventional
                        sources of energy for its daily power needs, correct disposal handling, purchase of eco-friendly
                        supplies, and an effective recycling program.
                    </p>

                    <p class="mt-8 text-[14px]">
                        The administration of the Institute believes that everyone has to work out the time-bound
                        strategies to implement green campus initiatives. These strategies need to be incorporated into
                        the institutional planning and budgeting processes to develop a clean and green campus. Every
                        individual on Arni university campus will work, may he/she be a student, faculty, or support
                        staff to foster a culture of self-sustainability and make the entire campus eco-friendly. The
                        Green Campus Initiatives will enable the university to develop the campus as a living laboratory
                        for renascence.
                    </p>
                    <table class="border m-auto mt-12 text-[14px]">
                        <tr class="py-1 border-b">
                            <td class="px-3 py-2 border-r ">
                                Principal of the Pharmacy and Paramedical Studies
                            </td>
                            <td class="px-3 py-2">
                                Prof. Neeraj Bhandari - Chairman
                            </td>
                        </tr>
                        <tr class="py-1 border-b">
                            <td class="px-3 py-2 border-r">
                                IQAC Director
                            </td>
                            <td class="px-3 py-2">
                                Dr. Raja Mannar – Secretary
                            </td>
                        </tr>
                        <tr class="py-1 border-b">
                            <td class="px-3 py-2 border-r">
                                Faculty Representative
                            </td>
                            <td class="px-3 py-2">
                                Dr. Sunita – Nominated
                            </td>
                        </tr>
                        <tr class="py-1 border-b">
                            <td class="px-3 py-2 border-r">
                                Student Representative
                            </td>
                            <td class="px-3 py-2">
                                Mr. Karan Dhingra – General Secretary
                            </td>
                        </tr>
                        <tr class="py-1 border-b">
                            <td class="px-3 py-2 border-r">
                                Non-Teaching Staff Representative
                            </td>
                            <td class="px-3 py-2">
                                Mr. Sohan Lal- Office Superintendent
                            </td>
                        </tr>
                        <tr class="py-1 border-b">
                            <td class="px-3 py-2 border-r">
                                Parent Representative
                            </td>
                            <td class="px-3 py-2">
                                Mr. Naresh Malpotra
                            </td>
                        </tr>
                        <tr class="py-1">
                            <td class="px-3 py-2 border-r">
                                ndustry Representative
                            </td>
                            <td class="px-3 py-2">
                                Mr. Trilochan Singh
                            </td>
                        </tr>


                    </table>
                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Role of the Go- Green Campus Programme
                    </h5>
                    <p class="mt-8 text-[14px]">
                        The inspiration for a successful Green Campus must begin at the top and emanate throughout the
                        rest of the campus. Without a strong message of commitment and involvement from both the
                        Chairperson and Members of the Committee, well-intentioned initiatives may be too fragmented to
                        allow for Institute- wide participation. Thus given this, the committee will plan and execute
                        to:
                    </p>
                    <ul class="list-disc mt-8 text-[13px] px-6">
                        <li>
                            Seek views of all the Stakeholders to make the Go Green Campus initiative functional
                            throughout the year.
                        </li>
                        <li>
                            Conduct the Campus' environmental impacts to identify the targets for improvements.
                        </li>
                        <li>
                            Establish a Green Campus Environmental Ethics Awareness campaign.
                        </li>
                        <li>
                            Set forth a Green Campus Mission and a Statement of Principles.
                        </li>
                        <li>
                            Link Green-Campus activities to Academics in the Institute.
                        </li>
                        <li>
                            Organize Awareness Programs for the students, faculty, and society.
                        </li>
                        <li>
                            Chart out a yearly planner for the Institute, local community, and Stakeholders.
                        </li>
                        <li>
                            Develop a strategic plan and create student teams to carry out specific tasks of the
                            strategic plan. For instance, a plan to save energy at the institute level with a time-bound
                            plan to install a Solar Power Station mandatorily either at the top of the Institute
                            building or in an open field. This will enable the institute to have a 24x7 power supply.
                        </li>
                        <li>
                            Phase-out the CFL and conventional light sources such as bulbs and tube lights, halogen and
                            mercury street/campus lights, and get them replaced by LEDs.
                        </li>
                        <li>
                            Conduct an Annual Green, Environment, and Energy Audit.
                        </li>
                        <li>
                            Purchase only Energy Efficient Computers viz: “ENERGY STAR” or any other equivalent.
                        </li>
                        <li>
                            Establish public/private partnerships with personnel from federal, state, and local
                            environmental agencies, utilities, and the business community.
                        </li>
                        <li>
                            Evaluate daily operations in terms of pollution prevention, waste stream management, and
                            energy efficiency reducing, reusing, recycling, and repairing wherever possible.
                        </li>
                        <li>
                            Secure a commitment upfront from the people in charge that well-founded recommendations will
                            be acted upon once audits are completed.
                        </li>
                    </ul>
                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Promotion of “Save Energy Tips” in and outside the Institute:
                    </h5>
                    <ul class="list-disc mt-8 text-[13px] px-6">
                        <li>
                            Activate power management features on your computer and monitor so that it will go into a
                            low power “sleep” mode when you are not working on it.
                        </li>
                        <li>
                            Turn off your monitor when you leave your Table.
                        </li>
                        <li>
                            Activate power management features on your laser printer.
                        </li>
                        <li>
                            Whenever possible, shut down rather than log off.
                        </li>
                        <li>
                            Turn off unnecessary lights and use daylight instead.
                        </li>
                        <li>
                            Avoid the use of decorative lighting.
                        </li>
                        <li>
                            Use LED or compact fluorescent bulbs.
                        </li>
                        <li>
                            Keep lights off in conference rooms, classrooms, and lecture halls when they are not in use.
                        </li>
                        <li>
                            Use the fans only when they are needed.
                        </li>
                        <li>
                            Unplug appliances not plugged into power strips (like TVs, Refrigerators, ACs,
                            tea/coffeepots, printers, faxes, chargers etc.)
                        </li>
                    </ul>
                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Promotion of “Save Energy Tips” in and outside the Institute:
                    </h5>
                    <p class="mt-8 text-[14px]">
                        The Institute has to work in the direction of wastewater management, particularly in student
                        hostels. Water flow restrictors on bathroom faucets and showers, low water flow toilets, and
                        automated urinal flushers should be used to cut down campus water use. The Institute will take
                        all necessary measures to implement wastewater management /rainwater harvesting.
                    </p>
                    <h5 class="font-semibold text-[18px] mt-16 text-gray-700">
                        Major Green Campus Initiatives:
                    </h5>
                    <ul class="list-disc mt-8 text-[13px] px-6">
                        <li>
                            ISO Certification 9001:2008
                        </li>
                        <li>
                            Installation of Solar Power Station
                        </li>
                        <li>
                            Wastewater Management/ Rainwater harvesting
                        </li>
                        <li>
                            Development of Sewage Water Treatment Plant
                        </li>
                        <li>
                            Use of Micro-scale techniques
                        </li>
                        <li>
                            Sensor-based energy conservation
                        </li>
                        <li>
                            Displayed poster on E-waste Management
                        </li>
                        <li>
                            Maintenance of water bodies and distribution systems on the campus
                        </li>
                        <li>
                            MIS to make paperless administration
                        </li>
                        <li>
                            Plastic-free Campus
                        </li>
                        <li>
                            Tree Plantation Drive
                        </li>
                        <li>
                            Cleanliness Drive
                        </li>
                        <li>
                            Landscaping and gardens
                        </li>
                        <li>
                            Use of LEDs only
                        </li>
                        <li>
                            Digital Library/ E-Learning Centre
                        </li>
                        <li>
                            Organization of sensitization programs for the stakeholders
                        </li>
                        <li>
                            Establishment of Enviro-Club
                        </li>
                        <li>
                            Green, Environment, and Energy Audit conducted
                        </li>
                        <li>
                            Restricted entry of automobiles
                        </li>
                        <li>
                            No Vehicle Day observed
                        </li>
                        <li>
                            The Institute will make all the necessary efforts to involve the students, faculty, and
                            staff in “Green Campus Initiatives” by designating the volunteers of Enviro Club, NSS & NCC
                            cadets, printing T-shirts/ Caps with the green campus initiative slogan specially designed
                            for the purpose.
                        </li>

                    </ul>
                </div>
                <div *ngIf="pageTitle === 'NCC'">
                    <h5 class="font-semibold text-[18px] text-gray-700 mt-8">
                        About Us
                    </h5>
                    <div class="flex flex-col md:flex-row mt-4">
                        <div class="w-full md:w-1/3 pt-0 md:pt-10">
                            <img src="./assets/img/ncc.jpeg" class="w-full h-auto object-cover border" alt="Ncc">
                        </div>
                        <div class="w-full md:w-2/3">
                            <p class="text-[14px] px-6 mt-8">
                                Arni University, Kathgarh, is located in the Indora region of Kangra, Himachal Pradesh.
                                The campus is surrounded by picturesque hills, offering a peaceful and serene
                                environment. The area is known for its lush greenery, natural beauty, and tranquility,
                                making it an ideal setting for academic growth and personal development.The National
                                Cadet Corps (NCC) is a voluntary organization fully controlled by the Ministry of
                                Defence. The Defence Secretary is overall in charge and is responsible to the Government
                                of India for the functioning of the NCC and all related matters. NCC cadets bear extra
                                responsibilities, unlike their fellow classmates who are not part of NCC. These
                                responsibilities are not formally written but are obligatory outcomes of their training,
                                making them the most disciplined members of the institution.NCC cadets fulfill the main
                                aims of NCC, which include developing leadership qualities, character, and responsible
                                citizenship. They hold additional responsibilities toward their NCC unit, organization,
                                institution, society, and the nation, which include active participation in social
                                awareness initiatives, environmental issues, disaster relief, adventure, sports
                                activities, and other nation-building efforts. Their duties do not end with their NCC
                                training at the institution but are carried forward to wherever they engage in the
                                future.

                                At present, the Army wing (SD) in Arni University, Indora, has 80 authorized vacancies,
                                with 33% reserved for girls. The NCC Army wing is associated with the 9 HP Bn NCC
                                Dalhousie.
                            </p>
                            <p class="text-[14px] px-6 mt-8">
                                NCC Officer
                            </p>
                            <p class="text-[14px] px-6">
                                Cadet Training Officer
                            </p>
                            <p class="text-[14px] px-6 mt-8">
                                Mr. Rohit Kumar
                            </p>
                            <p class="text-[14px] px-6">
                                Asst. Prof. Management & Commerce
                            </p>
                        </div>
                    </div>
                    <h5 class="font-semibold text-[18px] text-gray-700 mt-8">
                        National Cadet Corps (NCC)
                    </h5>
                    <div>
                        <h5 class="font-semibold text-[15px] text-gray-500 mt-6">
                            Brief History of NCC
                        </h5>
                        <p class="mt-4 text-[14px]">
                            The present day NCC came into existence on 16 Apr 1948, through XXXI Act of Parliament. NCC
                            was formally inaugurated on 15 Jul 1948, as soon as the schools and colleges reopened after
                            summer vacation. The Girls Division of the NCC was raised in July 1949. On 01 April 1950,
                            Air Wing was raised, with one Air squadron each at Bombay and Kolkata. The Naval Wing of the
                            NCC was raised in July 1952, thus completing the true representation of all services in the
                            Corps. Today the NCC has more than 13 Lakh strength. National Cadets Corps (NCC) day is
                            celebrated every year on the fourth Sunday in the month of November. NCC stands strong with
                            its Motto of “Unity and Discipline” The three colours in the NCC flag depict the three
                            services of the Corps, red for the Army, deep blue for the Navy and light blue for the Air
                            Force. The letters NCC and the NCC crest in gold in the middle of the flag encircled by a
                            wreath of lotus, give the flag a colourful look and a distinct identity.
                        </p>
                        <h5 class="font-semibold text-[15px] text-gray-500 mt-6">
                            Aims of NCC
                        </h5>
                        <ul class="list-disc mt-4 px-6 text-[14px]">
                            <li>
                                To develop following qualities in the cadets :(i) Development of Character. (ii)
                                Comradeship. (iii) Discipline. (iv) Secular Outlook. (v) Spirit of Adventure. (vi)
                                Sportsmanship. (vii) Ideals of selfless service among the youth of the country.
                            </li>
                            <li>
                                To create a human resource of Organized, Trained and Motivated youth, to provide
                                leadership in all walks of life and always be available for the service of the nation.
                            </li>
                            <li>
                                To provide a suitable environment to motivate the youth to take up a career in the Armed
                                Forces.
                            </li>
                        </ul>
                        <h5 class="font-semibold text-[15px] text-gray-500 mt-6">
                            Organization
                        </h5>
                        <ul class="list-disc mt-4 px-6 text-[14px]">
                            <li>
                                At the Headquarters level, this organization is headed by an officer of the rank of
                                Lieutenant General who is responsible for the functioning of the NCC in the country and
                                is called as DG NCC.
                            </li>
                            <li>
                                There are 17 Directorates located in the state capitals headed by an officer of the rank
                                of a Major General / Brigadier or equivalent from the three Services called as ADG.
                                Depending upon the size of the state and growth of NCC in the states, Directorates have
                                up to 14 Group Headquarters under them through which they exercise their command and
                                control of the organisation in the state. Each group is headed by an officer of the rank
                                of Brig / Colonel or equivalent known as Group Commander.
                            </li>
                            <li>
                                Each NCC Group Headquarters controls 5-7 NCC units / battalions, commanded by Colonel /
                                Lieutenant Colonel or equivalent. Each battalion consists of companies which are
                                commanded by the Associate NCC Officers (ANO) of the rank of Lieutenant, Captain or
                                Major. In all, there are 95 Group Headquarters in the country who exercise control over
                                a network of 667 Army Wing Units (including technical and girls unit), 60 Naval Wing
                                Units and 61 Air Squadrons.
                            </li>
                            <li>
                                There are two training establishments namely Officers Training School, Kamptee and Women
                                Officers Training School, Gwalior where professors and teachers from colleges and
                                schools are specially trained to impart training to the cadets as Associate NCC Officers
                                (ANOs).
                            </li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Extra Curricular Activities'">
                    <div class="flex flex-col md:flex-row gap-6 mt-12">
                        <div class="w-full md:w-1/3">
                            <img src="./assets/img/extra-curricular.jpeg" class="w-full h-auto overflow-hidden"
                                 alt="Extra curricular activities">
                        </div>
                        <div class="w-full md:2/3">
                            <p class="mt-4 text-[14px]">
                                National Webinar on National Education Policy 2020 was organized on Feb 25, 2021 under
                                the
                                Institutionâ€™s Innovation Council (Ministry of HRD) by Prof. Kamlesh Misra, Vice
                                Chancellor, Rishihood University, Sonepat.
                            </p>
                        </div>
                    </div>

                </div>
                <div *ngIf="pageTitle === 'Auditorium'">
                    <p class="mt-8 text-[14px]">
                        Aarni University boasts five state-of-the-art auditoriums designed to host a variety of international, national, and university-level events such as conferences, workshops, seminars, meetings, placement programs, and cultural performances. These auditoriums provide a sophisticated and professional setting for academic and extracurricular activities.
                        Each auditorium is well-furnished, centrally air-conditioned, and equipped with advanced projection and audio systems with seamless internet access. The design features traditional theatre-style seating, a spacious raised stage, adjustable lighting, a high-quality sound system, and a large screen for multimedia presentations. The vaulted ceilings and strategic architecture ensure an unobstructed view of the stage from every seat, offering an immersive and engaging experience for the audience.
                    </p>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 py-12 gap-8">
                        <div class="bg-white w-full shadow-lg border pb-6" *ngFor="let auditorium of auditoriums">
                            <div>
                                <img [src]="auditorium.image_url" class="w-full h-auto" [alt]="auditorium.name">
                            </div>
                            <h6 class="font-semibold text-[18px] pt-8 pb-6 px-4">
                                {{ auditorium.name }}
                                <div class="bg-gold h-[2px] w-[32%]"></div>
                            </h6>
                            <p class="px-4 line-clamp-3 text-[14px]">
                                {{ auditorium.description }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>
